export const isCollaborationAppEnabled = (
    session,
    virtualSession,
    activitiesLiveStatus,
    isWaitingRoomActive
) => {
    const virtualSessionError = virtualSession.isLoading || virtualSession.isError;

    if (virtualSessionError) {
        return false;
    }

    const isQnaEnabled = !!session.data?.qna?.enable;
    const isChatEnabled = !!session.data?.chat?.enable;
    const isQnaOrChatEnabled = isQnaEnabled || isChatEnabled;

    const isCollaborationActive =
        !!activitiesLiveStatus.data?.[session.data?.id]?.isCollaborationActive;

    return (isCollaborationActive || isWaitingRoomActive) && isQnaOrChatEnabled;
};
